import { notifyError } from "../../helpers/helpers";
import { auction } from "../config/urlConfig";

export const getpcbOfferRequest =
  (currentPage, totalNumberRow, auctionFilter) => async (dispatch) => {
    const skip = (currentPage - 1) * totalNumberRow;
    dispatch({ type: "PCB_OFFER_LOADING" });
    try {
      const { data } = await auction.get(
        `/auction/read/pcb-offers?auctionType=${auctionFilter}&skip=${skip}&limit=${totalNumberRow}`
      );
      dispatch({ type: "GET_PCB_OFFER", payload: data });
    } catch (error) {
       notifyError(error.response ? error.response?.data : error.message,error.response?.status);
      dispatch({ type: "PCB_OFFER_LOADDED" });
    }
  };
